"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mockedFetchProductsActivationInfo = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var mockedFetchProductsActivationInfo = function mockedFetchProductsActivationInfo() {
  return _promise["default"].resolve({
    products: {
      appoptics: 'can_activate',
      loggly: 'access_needed',
      papertrail: 'can_activate',
      pingdom: 'can_activate'
    },
    hasCombinedNavigation: true
  });
};

exports.mockedFetchProductsActivationInfo = mockedFetchProductsActivationInfo;